<template>
  <div>
    <q-card class="auth-card relative-position">
      <q-card-main>
        <check-mark></check-mark>

        <h4 class="text-center">{{ $t('user_deleted_title') }}</h4>

        <p class="text-center">{{ $t('user_deleted_body') }}</p>
      </q-card-main>
    </q-card>
  </div>
</template>

<script>
  import CheckMark from 'components/Common/Animations/Checkmark.vue'
  import { UserClient } from 'src/api/Users'
  import router from 'src/router'
  import store from 'src/store'

  export default {
    beforeRouteEnter (to, from, next) {
      let token = to.params.token

      new UserClient().confirmDeletion(token)
        .then(() => {
          setTimeout(() => {
            router.push({ name: 'login' })
          }, 5000)

          if (store.getters.authenticated) {
            store.dispatch('logout')
          }

          next()
        })
    },

    components: {
      CheckMark
    }
  }
</script>
